import { createSlice, current } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import _ from "lodash";
import { apiCallBegan } from "./api";
import {
  DATE,
  FormProperties,
  MULTISELECT,
  PERCENTAGE,
  SIMPLESTRING,
  SINGLESELECT,
  YESNO,
  EMAIL,
  CURRENCY,
  CONTACT,
  initialBoostFormstateIfNull,
  SINGLESELECTPLATINUM,
  addLocation,
  removeLocation,
  removeBuilding,
  addExtraOperation_Form,
  MULTISELECTPLATINUM,
  YEAR,
  NUMBER,
  ADDRESS,
  LARGESTRING,
  MULTISTRING,
  MULTITEXT,
  SCHEDULE,
  DOCUPLOAD,
  OPERATIONTABLE,
  INSURER,
  CLIENT,
  isOnlyOneLocationAvaliable,
  addBuilding,
  initializeBuilding,
} from "./businesslogic/hardwiredlogic";
import {
  figureOutNextNodeOnDirectGroupClick,
  figureOutNextNodeOnDirectLocationClick,
  figureOutNextNodeOnDirectLocationGroupClick,
  figureOutNextNodeOnDirectBuildingClick,
  figureOutNextNodeOnNextClick,
  figureOutPreviousNodeOnPreviousClick,
  grabAllPermanentCodeQuestionAtOnePlace,
  handleMultiSelectAnswerChange,
  handleSingleSelectAnswerChange,
  handleYesNoAnswerChange,
  handleBundleSetAnswerChange,
  handleSimpleStringAnswerChange,
  PossibleApiStatusValues,
  setCurrentNodeIfEmpty,
  setCurrentNodesToFirstOfItsNodestate,
  updateNodeTime,
  updateTrackingQAnsweredFinalValuesHelper,
} from "./helperfuncs";
import { giveLocationAddresses } from "common-func-quotey";

const initialState = {
  prospectid: null,
  isBpFetching: false,
  isBpFetchFailed: false,
  isBpFetchSuccess: false,
  doc: null,
  scheduleFile: null,
  formsorder: [],
  formstate: {},
  clientLog: [],
  updating: false,
  isUpdated: false,
  updatingBMS: false,
  isUpdateFailed: false,
  gmapPredictions: [],
  gmapSearchInitialized: false,
  gmapSearchFailed: false,
  gmapSearchDoneWithSucess: true,
  gmapPostalCodeData: {},
  showFirstAutoAddedBuilding: true,
  openCHSconfirmationModal: false,
  isExpressApplication: false,
  expressImportanceFactor: 3,
  nonPriorityGroups: [],
  chsdataloading: PossibleApiStatusValues.notstarted,
  trackingQAnsweredFinalValues: {
    totalQs: 0,
    totalQAnswered: 0,
    totalImp: 0,
    totalImpAnswered: 0,
    totalUnAnsweredQuestion: 0,
    totalNonAnswerableQuestion: 0,
    totalAnswerableQuestions: 0,
    formsorderConsidered: [],
  },
  trackingQAnsweredEachForm: {},
  bms: {},
  bmsinitalclient: true,
  bmsPayload: {},
  flashQid: null,
  bypassImportanceQ: false,
  updareFormError : null,
};

const slice = createSlice({
  name: "qf",
  initialState,
  reducers: {
    resetState: (qf) => {
      qf.documentPayload = null;
    }, // This reducer resets the state
    storeProspectIdFromQF: (qf, action) => {
      qf.prospectid = action.payload;
    },
    bpFetchInitialized: (qf, action) => {
      qf.isBpFetching = true;
      qf.isBpFetchSuccess = false;
      qf.isBpFetchFailed = false;
    },
    setShowFirstAutoAddedBuilding: (qf, action) => {
      qf.showFirstAutoAddedBuilding = action.payload;
    },
    initiateCustomerSucceed: (qf, action)=> {
      if(qf.doc?.otherdetails?.addclientinfo){
        qf.doc.otherdetails.addclientinfo = false;
      }
    },
    bpFetchSucceed: (qf, action) => {
      qf.isBpFetching = false;
      qf.isBpFetchSuccess = true;
      qf.isBpFetchFailed = false;
      qf.questiontable = action.payload.questiontable;
      qf.doc = action.payload.prospectdoc;
      qf.chs = action.payload.chs;

      initialBoostFormstateIfNull({ qf });
      // make the operations_ group

      setCurrentNodeIfEmpty({ qf });

      qf.formsorder = action.payload.prospectdoc.formsorder;
      qf.formstate = action.payload.prospectdoc.formstate;

      // handling permanent code stuff
      qf.permanentcodes = grabAllPermanentCodeQuestionAtOnePlace({
        formstate: qf.formstate,
        formsorder: qf.formsorder,
      });

      // This is for The CHS screen
      qf.chsdataloading = PossibleApiStatusValues.success;
    },

    bpFetchFailure: (qf, action) => {
      qf.isBpFetching = false;
      qf.isBpFetchSuccess = false;
      qf.isBpFetchFailed = true;
    },

    gmapPredictionInitalized: (qf, action) => {
      qf.gmapSearchDoneWithSucess = false;
      qf.gmapSearchFailed = false;
      qf.gmapSearchInitialized = true;
    },

    gmapPredictionSucceed: (qf, action) => {
      qf.gmapSearchDoneWithSucess = true;
      qf.gmapSearchFailed = false;
      qf.gmapSearchInitialized = false;
      qf.gmapPredictions = action.payload.predictions;
    },

    scheduleFileSucceed: (qf, action) => {
      qf.scheduleFile = action.payload;
    },
    scheduleFileStart: (qf, action) => {
      qf.scheduleFile = null;
    },

    gmapPredictionFailed: (qf, action) => {
      qf.gmapSearchDoneWithSucess = false;
      qf.gmapSearchFailed = true;
      qf.gmapSearchInitialized = false;
    },

    gmapPostalCodeSucceed: (qf, action) => {
      qf.gmapPostalCodeData = action.payload;
    },

    currentNodeChanged: (qf, action) => {
      let newUpdateNode = updateNodeTime(qf.formstate, action.payload);
      qf.formstate.currentnode = newUpdateNode;
    },

    currentNodeChangedOnDirectClick: (qf, action) => {
      const formid = action.payload;
      const formCurrentNode = qf.formstate[formid].currentnode;
      qf.formstate.currentnode = formCurrentNode;
      updateNodeTime(qf.formstate, formCurrentNode);
    },
    openCHSconfirmationModalFun: (qf, action) => {
      qf.openCHSconfirmationModal = action.payload;
    },

    currentNodeChangedOnDirectGroupClick: (qf, action) => {
      const groupid = action.payload;
      const formCurrentNode = figureOutNextNodeOnDirectGroupClick({
        formstate: qf.formstate,
        groupid,
      });
      if (formCurrentNode) {
        qf.formstate.currentnode = formCurrentNode;
        updateNodeTime(qf.formstate, formCurrentNode);
      }
    },

    currentNodeChangedOnDirectLocationGroupClick: (qf, action) => {
      const { groupid, locationid } = action.payload;
      const formCurrentNode = figureOutNextNodeOnDirectLocationGroupClick({
        formstate: qf.formstate,
        groupid,
        locationid,
      });
      if (formCurrentNode) {
        qf.formstate.currentnode = formCurrentNode;
        updateNodeTime(qf.formstate, formCurrentNode);
      }
    },

    currentNodeChangedOnDirectLocationClick: (qf, action) => {
      const { locationid } = action.payload;
      const formCurrentNode = figureOutNextNodeOnDirectLocationClick({
        formstate: qf.formstate,
        locationid,
      });
      if (formCurrentNode) {
        qf.formstate.currentnode = formCurrentNode;
        updateNodeTime(qf.formstate, formCurrentNode);
      }
    },
    currentNodeChangedOnDirectBuildingClick: (qf, action) => {
      const { locationid, buildingid } = action.payload;

      const formCurrentNode = figureOutNextNodeOnDirectBuildingClick({
        formstate: qf.formstate,
        locationid,
        buildingid,
      });

      if (formCurrentNode) {
        qf.formstate.currentnode = formCurrentNode;
        updateNodeTime(qf.formstate, formCurrentNode);
      }
    },

    currentNodeChangeOnNextClick: (qf, action) => {
      let nextNode = figureOutNextNodeOnNextClick({
        formsorder: qf.formsorder,
        formstate: qf.formstate,
        isExpressApplication: qf.isExpressApplication,
        nonPriorityGroups: qf.nonPriorityGroups,
      });

      if (nextNode) {
        qf.formstate.currentnode = nextNode;
        updateNodeTime(qf.formstate, nextNode);
      }
    },

    currentNodeChangeOnPreviousClick: (qf, action) => {
      let previousNode = figureOutPreviousNodeOnPreviousClick({
        formsorder: qf.formsorder,
        formstate: qf.formstate,
        isExpressApplication: qf.isExpressApplication,
        nonPriorityGroups: qf.nonPriorityGroups,
      });

      if (previousNode) {
        qf.formstate.currentnode = previousNode;
        updateNodeTime(qf.formstate, previousNode);
      }
    },

    changeNodeOfScheduleQuestion: (qf, action) => {
      let { node, changedValue } = action.payload;

      qf.formstate[node.formid].nodestate[node.id] = {
        ...node,
        modalstate: changedValue,
      };
    },

    updateFormsInitiated: (qf, action) => {
      qf.updating = true;
      qf.isUpdateFailed = false;
      qf.isUpdated = true;
    },

    updateBMSInitiated: (qf, action) => {
      qf.updatingBMS = true;
      qf.bmsPayload = {};
    },

    updateFormsSuccess: (qf, action) => {
      qf.updating = false;
      qf.isUpdateFailed = false;
      qf.isUpdated = true;
      qf.updareFormError = null;
    },
    updateBMSSuccess: (qf, action) => {
      qf.updating = false;
      qf.isUpdateFailed = false;
      qf.isUpdated = true;
      qf.updatingBMS = false;
      qf.bmsPayload = action.payload;
    },

    updateDocumentSuccess: (qf, action) => {
      qf.documentSuccess = true;
      qf.documentPayload = action.payload;
    },
    updateOperationSuccess: (qf, action) => {
      if (action.payload.prospectdoc) {
        qf.formstate = action.payload.prospectdoc.formstate;
        qf.doc.answers.operations.list =
          action.payload.prospectdoc.answers.operations.list;
      }
    },

    updateFormsFailed: (qf, action) => {
      qf.updating = false;
      qf.isUpdateFailed = true;
      qf.isUpdated = false;
      qf.updareFormError = action.payload;
    },

    addLocationToForm: (qf, action) => {
      let newQf = addLocation({ qf: { ...qf }, formid: action.payload.formid });
      qf.formstate = newQf.formstate;
    },

    //Need to first intialize the building when the first building gets added.
    addBuildingToForm: (qf, action) => {
      let newQf = addBuilding({
        qf: { ...qf },
        formid: action.payload.formid,
        locationid: action.payload.locationid,
        buildingIndex: action.payload.buildingIndex,
      });

      qf.formstate = newQf.formstate;
      //to implement, every time a new building is added it is always 1 question usally the first building. I need to search thru the keys of the nodestate then find that new building
      //based on the buildingId then grab the data inside which is the "node data" and then set intide currentnode and use updateNodeTime to move the vison thier
      let obj = qf.formstate[action.payload.formid].nodestate; // your object
      let matchString =
        "location_" +
        action.payload.locationid +
        "_building_" +
        action.payload.buildingIndex; // your partial match string

      // use this to search for the first match
      let firstMatchKey = _.findKey(obj, (value, key) =>
        _.includes(key, matchString)
      );

      // the current new node for the buliding just added
      const newBuildingNodeFirstQuestion =
        qf.formstate[action.payload.formid].nodestate[firstMatchKey];

      if (
        action.payload.buildingIndex === 0 &&
        !qf.formstate[action.payload.formid].locationstate[action.payload.locationid][
          "buildingFirstQuestion"
        ]
      ) {
        let tempNewBuildingNodeFirstQuestion = _.cloneDeep(
          newBuildingNodeFirstQuestion
        );
        delete tempNewBuildingNodeFirstQuestion.id;
        delete tempNewBuildingNodeFirstQuestion.buildingid;
        delete tempNewBuildingNodeFirstQuestion.locationid;
        qf.formstate[action.payload.formid].locationstate[action.payload.locationid][
          "buildingFirstQuestion"
        ] = tempNewBuildingNodeFirstQuestion;
      }

      if (
        action.payload.buildingIndex === 0 &&
        qf.formstate[action.payload.formid].locationstate[action.payload.locationid][
          "buildingFirstQuestion"
        ]
      ) {
        qf.formstate[action.payload.formid].nodestate[firstMatchKey] = {
          locationid: newBuildingNodeFirstQuestion.locationid,
          buildingid: newBuildingNodeFirstQuestion.buildingid,
          id: newBuildingNodeFirstQuestion.id,
          ...qf.formstate[action.payload.formid].locationstate[action.payload.locationid][
            "buildingFirstQuestion"
          ],
        };

        // console.log(
        //   "very qf.formstate[action.payload.formid].nodestate ",
        //   JSON.parse(
        //     JSON.stringify(qf.formstate[action.payload.formid].nodestate)
        //   )
        // );
      }

      // code to move the focus to the new building
      if (
        firstMatchKey &&
        newBuildingNodeFirstQuestion &&
        !action.payload.focusDisabled
      ) {
        qf.formstate.currentnode = newBuildingNodeFirstQuestion;
        updateNodeTime(qf.formstate, newBuildingNodeFirstQuestion);
      }
    },

    removeLocationToForm: (qf, action) => {
      let newQf = removeLocation({
        qf: { ...qf },
        formid: action.payload.formid,
        locationid: action.payload.locationid,
      });
      qf.formstate = newQf.formstate;
      qf.formsorder = newQf.formsorder;
    },
    removeBuildingToForm: (qf, action) => {
      let newQf = removeBuilding({
        data: { ...qf },
        formid: action.payload.formid,
        locationid: action.payload.locationid,
        buildingIndexToDelete: action.payload.buildingid,
      });
      qf.formstate = newQf.formstate;
      qf.formsorder = newQf.formsorder;
    },

    AddtoClientLog: (qf, action) => {
      let { newentry } = action.payload;
      qf.clientLog.push(newentry);
    },

    answerChanged: (qf, action) => {
      let { node, changedValue, isBuilding } = action.payload;
      const { type, id, formid, locationid } = node; 
  
     
      // questions which do not have any actions to do, simply put answer
      if (
        [
          SIMPLESTRING,
          PERCENTAGE,
          DATE,
          EMAIL,
          CURRENCY,
          CONTACT,
          MULTISELECTPLATINUM,
          YEAR,
          NUMBER,
          LARGESTRING,
          MULTITEXT,
          MULTISTRING,
          SCHEDULE,
          DOCUPLOAD,
          OPERATIONTABLE,
        ].includes(type)
      ) {
        qf.formstate[formid].nodestate[id].answer = changedValue;
      }
  
    
      if (type === ADDRESS) {
        const addressNode = qf.formstate[formid].nodestate[id];
        // Set the main answer as before
        addressNode.answer = changedValue;
  
        // Now, check if this is a location address that needs caching
        if (locationid) {
          // Find the corresponding "Same as Main?" question for this location
          const sameAddressQuestion = qf.formstate[formid].nodestate[`location_${locationid}_500100`];
          
          // If the user has selected "No", we cache their manual input
          if (sameAddressQuestion && sameAddressQuestion.answer === "No") {
            addressNode.customAnswer = changedValue;
          }
        }
      }
      if(type == 'bundleset'){
        let wholeQF = handleBundleSetAnswerChange({
          qf: { ...qf },
          node,
          changedValue,
        });
  
        qf.formsorder = wholeQF.formsorder;
        qf.formstate = wholeQF.formstate;
      }
  
      if (type === YESNO) {
        let wholeQF = handleYesNoAnswerChange({
          qf: { ...qf },
          node,
          changedValue,
        });
        const locationid = node.locationid;
        if (
          wholeQF?.formstate[formid] &&
          wholeQF?.formstate[formid]?.locationstate &&
          wholeQF?.formstate[formid]?.locationstate[locationid].buildings &&
          wholeQF?.formstate[formid]?.locationstate[locationid].buildings[0]
            .groupsorder.length > 0 &&
          wholeQF.formstate[formid]?.locationstate[locationid]
            .autoBuildingHasBeenAdded
        ) {
          if (
            wholeQF.formstate[formid].locationstate[locationid]?.[
              "buildingIntialState"
            ] === undefined // this will make sure we check if this exist so we dont overwrite the existing state
          ) {
            //temp fix to issue with storing a consist state
            wholeQF.formstate[formid].locationstate[locationid]["buildingIntialState"] =
              wholeQF.formstate[
                formid
              ].locationstate[locationid].buildings[0].groupstate["e_100_50"];
          }

          // if (wholeQF.formstate[formid].locationstate[1].buildings.length < 1) {
          wholeQF.formstate[formid].locationstate[locationid].buildings[0] = {
            groupsorder: [],
            groupstate: {},
          };
          // }

          wholeQF.formstate[formid].locationstate[
            locationid
          ].autoBuildingHasBeenAdded = false;
        }
  
        qf.formsorder = wholeQF.formsorder;
        qf.formstate = wholeQF.formstate;
      }
      if (type === SINGLESELECT || type === SINGLESELECTPLATINUM) {
        let wholeQF = handleSingleSelectAnswerChange({
          qf: { ...qf },
          node,
          changedValue,
          isBuilding,
        });
        const formid = node.formid;

        // let tempBuilding = _.cloneDeep(
        //   newFormstate.locationstate[locationid].buildings[0].groupstate["e_100_50"]
        // );
        const locationid = node.locationid;
        if (
          wholeQF?.formstate[formid] &&
          wholeQF?.formstate[formid]?.locationstate &&
          wholeQF?.formstate[formid]?.locationstate[locationid].buildings &&
          wholeQF?.formstate[formid]?.locationstate[locationid].buildings[0]
            .groupsorder.length > 0 &&
          wholeQF.formstate[formid]?.locationstate[locationid]
            .autoBuildingHasBeenAdded
        ) {
          if (
            wholeQF.formstate[formid].locationstate[locationid] &&
            wholeQF.formstate[formid].locationstate[locationid][
              "buildingIntialState"
            ] === undefined // this will make sure we check if this exist so we dont overwrite the existing state
          ) {
            //temp fix to issue with storing a consist state
            wholeQF.formstate[formid].locationstate[locationid]["buildingIntialState"] =
              wholeQF.formstate[
                formid
              ].locationstate[locationid].buildings[0].groupstate["e_100_50"];
          }

          // if (wholeQF.formstate[formid].locationstate[1].buildings.length < 1) {
          wholeQF.formstate[formid].locationstate[locationid].buildings[0] = {
            groupsorder: [],
            groupstate: {},
          };
          // }

          wholeQF.formstate[formid].locationstate[
            locationid
          ].autoBuildingHasBeenAdded = false;
        }
        qf.formsorder = wholeQF.formsorder;
        qf.formstate = wholeQF.formstate;
      }
      if (type === MULTISELECT) {
        let wholeQF = handleMultiSelectAnswerChange({
          qf: { ...qf },
          node,
          changedValue,
        });
        qf.formsorder = wholeQF.formsorder;
        qf.formstate = wholeQF.formstate;
      }
      if (
        type == SIMPLESTRING ||
        [
          LARGESTRING,
          YEAR,
          NUMBER,
          PERCENTAGE,
          CURRENCY,
        ].includes(type)
      ) {
        let wholeQF = handleSimpleStringAnswerChange({
          qf: { ...qf },
          node,
          changedValue,
        });
        qf.formsorder = wholeQF.formsorder;
        qf.formstate = wholeQF.formstate;
      }
    },

    addMetaData: (qf, action) => {
      let { node, metaValue } = action.payload;
      const { type } = node;
      if (!qf.formstate[node.formid].nodestate[node.id].metaData) {
        qf.formstate[node.formid].nodestate[node.id].metaData = {};
      }
      qf.formstate[node.formid].nodestate[node.id].metaData = {
        ...qf.formstate[node.formid].nodestate[node.id].metaData,
        ...metaValue,
      };
    },

    manipulateQuestion: (qf, action) => {
      let { node, key, newValue } = action.payload;
      qf.formstate[node.formid].nodestate[node.id][key] = newValue;
      const item = qf.questiontable.find(item => item.id === node.id);
      if (item) item[key] = newValue;
    },

    implementProductGroupsandQuestions: (qf, action) => {
      let {addgroups, addquestions, type, productid, addforms } = action.payload;
      // old application without triage return early
      if(!qf.doc.otherdetails?.triagedata) { return }      
      if(type == 'remove'){
        qf.doc.otherdetails.triagedata.packageDetails[productid] = null;
        if(addforms){
          let locationType = productid == 'Property';
          for(let addFormId of addforms){
            if(qf.formstate.currentnode.formid == addFormId){
              // check to see if current node is in this form,
              //  if change currentnode to different form and delete form
              let firstformid = qf.formsorder.find(x => x != addFormId);
              qf.formstate.currentnode = qf.formstate[firstformid].currentnode
            }
            delete qf.formstate[addFormId];
            qf.formsorder = qf.formsorder.filter(x => x != addFormId);
          }
        }
        if(addquestions){
          for(let itemToRemove of addquestions){
            let formid = itemToRemove.formid;
            let groupid = itemToRemove.groupid;
            qf.formstate[formid].groupstate[groupid].questionsorder = qf.formstate[formid].groupstate[groupid].questionsorder.filter(x => !itemToRemove.qid.includes(x)  );
            qf.formstate[formid].nodesorder = qf.formstate[formid].nodesorder.filter(x => !itemToRemove.qid.includes(x)  );
            qf.doc.otherdetails.triagedata.addQuestions = qf.doc.otherdetails.triagedata.addQuestions.filter(item => {
              // Check if formid and groupid match
              if (item.formid !== itemToRemove.formid || item.groupid !== itemToRemove.groupid) {
                return true; // Keep if formid or groupid doesn't match
              }
              // Check if qid arrays are different (length or elements)
              if (item.qid.length !== itemToRemove.qid.length) {
                return true; // Keep if lengths differ
              }
              return !item.qid.every((q, index) => q === itemToRemove.qid[index]); // Keep if qid arrays differ
            });
            //delete qf.formstate[formid].nodestate[qid]
          }
        }
        if(addgroups){        
          for(let removeGroup of addgroups){
            removeGroup.gid.forEach(groupid => {
              let groupQuestions = qf.questiontable.filter(x => x.groupid == groupid).map(x=> ({...x, 'questionid': x.id, "formtype":"operation", "formid": removeGroup.formid }))
              let groupQuestionIds = groupQuestions.map(x => x.id)
              qf.formstate[removeGroup.formid].groupsorder = qf.formstate[removeGroup.formid].groupsorder.filter(x => x != removeGroup.gid );
              qf.formstate[removeGroup.formid].nodesorder =  qf.formstate[removeGroup.formid].nodesorder.filter(x => !groupQuestionIds.includes(x) )
              groupQuestions.forEach(question => {
                //qf.doc.formstate[addgroup.formid].nodestate[question.id] = question 
                delete qf.formstate[removeGroup.formid].nodestate[question.id] 
              })
            })
          }
        }     
      }
      else{
        //when type == 'adding'
        qf.doc.otherdetails.triagedata.packageDetails[productid] = 'Package';
        if(addforms){
          let locationType = productid == 'Property';
          for(let addFormId of addforms){
            qf.formsorder.push(addFormId)
            let groups = Object.values(qf.doc.groupstable).filter(x => x.formid == addFormId)
            // works for location, need to test non-location form type
            qf.formstate[addFormId] = {
              ...qf.doc.formstable[addFormId],
              //groupsorder: groups.map(x => x.id), 
              nodesorder:[],
              nodestate:{},
              //groupsorder: groups.map(x => x.id),
              //groupstate:{},
              locationsorder: locationType ? [ 1 ] : null,
              locationstate:  locationType ? { 1: {  groupsorder: groups.map(x => x.id),   } } : null
            }
            let groupState = {}
            for(let group of groups){
              let groupQuestions = qf.questiontable.filter(x => x.groupid == group.id).map(x=> ({...x, 'questionid': x.id, "formtype":"location", "formid": addFormId }))
              groupState[group.id] = {
                ...group,
                questionsorder: groupQuestions.map(x => x.id),
                formid: addFormId,
              }
              groupQuestions.forEach(question => {
                //qf.doc.formstate[addgroup.formid].nodestate[question.id] = question 
                question.id = locationType ?  'location_1_'+ question.id : question.id
                question.locationid = locationType ?  1 : null
                qf.formstate[addFormId].nodestate[question.id] = question 
                if(!qf.formstate[addFormId].currentnode){
                  qf.formstate[addFormId].currentnode = question;
                }
                qf.formstate[addFormId].nodesorder.push(question.id)
              })
              qf.formstate[addFormId].nodesorder.sort();
            }
            if(locationType){
              qf.formstate[addFormId].locationstate[1].groupstate = groupState;
              qf.formstate[addFormId].locationstate[1].buildings = [{"groupsorder": [],
              "groupstate": {}}];
              qf.formstate[addFormId].locationstate[1].buildingIntialState = undefined;
              qf.formstate[addFormId].locationstate[1].buildingFirstQuestion = undefined;
            }else{
              //qf.formstate[addFormId].groupstate = groupState;
            }
          }
          qf.formsorder.sort();
        }
        if(addgroups){
          for(let addgroup of addgroups){
            //qf.doc.formstate[addgroup.formid].groupsorder.push(...addgroup.gid);
            qf.formstate[addgroup.formid].groupsorder.push(...addgroup.gid);
            addgroup.gid.forEach(groupid => {
              let groupQuestions = qf.questiontable.filter(x => x.groupid == groupid).map(x=> ({...x, 'questionid': x.id, "formtype":"operation", "formid": addgroup.formid }))
              let newGroup = {
                ...qf.doc.groupstable[groupid],
                questionsorder: groupQuestions.map(x => x.id),
                formid: addgroup.formid,
                //verticalids:[67]
              }
              qf.formstate[addgroup.formid].nodesorder.push(...groupQuestions.map(x => x.id))
              //qf.doc.formstate[addgroup.formid].nodesorder.push(...groupQuestions.map(x => x.id))
              
              groupQuestions.forEach(question => {
                //qf.doc.formstate[addgroup.formid].nodestate[question.id] = question 
                qf.formstate[addgroup.formid].nodestate[question.id] = question 
              })
              qf.formstate[addgroup.formid].groupstate[groupid] = newGroup;
              //qf.doc.formstate[addgroup.formid].groupstate[groupid] = newGroup;
            })
            qf.formstate[addgroup.formid].nodesorder.sort();
            qf.formstate[addgroup.formid].groupsorder.sort()
          }
        }
        if(addquestions){
          qf.doc.otherdetails.triagedata.addQuestions.push(...addquestions)
          for(let set of addquestions){
            let newFormBool = false;
            let formid = set.formid;
            let groupid = set.groupid;
            if(!qf.formstate[formid]){
              // if form doesnt exists we create it
              qf.formsorder.push(formid)
              let newForm = {
                ...qf.doc.formstable[formid],
                'nodesorder':[],
                'nodestate': {},
                'groupsorder': [],
                'groupstate':{},

              }
              qf.formstate[formid] = newForm;
              newFormBool = true;
            }
            if(!qf.formstate[formid].groupstate[groupid]){
              let newGroup = {
                ...qf.doc.groupstable[groupid],
                formid: formid,
                questionsorder: [],
                //verticalids:[67]
              }
              qf.formstate[formid].groupstate[groupid] = newGroup
              qf.formstate[formid].groupsorder.push(groupid);
            }
            for(let qid of set.qid){        
              qf.formstate[formid].groupstate[groupid].questionsorder.push(qid);
              qf.formstate[formid].nodesorder.push(qid);
              const item = {
                ...qf.questiontable.find(item => item.id === qid),
                formtype: "mastergroup",
                questionid: qid,
                time: 0,
                prospectid: qf.prospectid,
                formid,
                groupid
              };
              if(!qf.formstate[formid].nodestate[qid]){
                qf.formstate[formid].nodestate[qid] = item;
                if(newFormBool){
                  newFormBool = false;
                  qf.formstate[formid].currentnode = item;
                }
              }

            }
            qf.formstate[formid].groupstate[groupid].questionsorder.sort();
            qf.formstate[formid].nodesorder.sort()
          }
        }
      }
      // update productCode accordingly; 
      let oldProductCode = qf.doc.answers.productcode;
      if(oldProductCode == 'GeneralLiability'){
        if(type == 'add' && productid == 'Property'){
          //console.log(`Converting Product Code from ${oldProductCode} to Commercial Package `);
          qf.doc.answers.productcode = 'Commercial Package';
        }
        
      }
      if(oldProductCode == 'Commercial Package'){
        if(type == 'remove' && productid == 'Property'){
          //console.log(`Converting Product Code from ${oldProductCode} to General Liability `);
          qf.doc.answers.productcode = 'GeneralLiability';
        }
      }

    },

    dataForCHSInitialized: (qf, action) => {
      qf.chsdataloading = PossibleApiStatusValues.loading;
    },

    dataForCHSFailed: (qf, action) => {
      qf.chsdataloading = PossibleApiStatusValues.failed;
    },

    makeCurrentNodesToFirstNode: (qf, action) => {
      let { formstate, formsorder } = setCurrentNodesToFirstOfItsNodestate({
        formstate: qf.formstate,
        formsorder: qf.formsorder,
      });
      qf.formstate = formstate;
      qf.formsorder = formsorder;
    },

    updateTrackingQAnsweredFinalValues: (qf, action) => {
      let { trackingQAnsweredEachForm, trackingQAnsweredFinalValues } =
        updateTrackingQAnsweredFinalValuesHelper({
          formsorder: qf.formsorder ? [...qf.formsorder] : [],
          formstate: qf.formstate ? { ...qf.formstate } : {},
          trackingQAnsweredEachForm: { ...qf.trackingQAnsweredEachForm },
          trackingQAnsweredFinalValues: { ...qf.trackingQAnsweredFinalValues },
          formChangedId: action.payload
            ? action.payload.formChangedId
              ? action.payload.formChangedId
              : null
            : null,
        });

      qf.trackingQAnsweredEachForm = trackingQAnsweredEachForm;
      qf.trackingQAnsweredFinalValues = trackingQAnsweredFinalValues;
    },

    prefillAddressParts: (qf, action) => {
      let formid = action.payload.formid;
      let { formstate, formsorder, doc } = qf;
      let answers = { doc };
      let { order, state } = giveLocationAddresses({
        formsorder,
        formstate,
        answers,
      });
      let { locationsorder, locationstate } = qf.formstate[formid];
      let locations_ = Object.values(qf.formstate[formid].nodestate).filter(
        (x) => x.questionid == "500100"
      );

      // need to get the correct key for location since its dynamic, then use this key as the grounding point to refrence data
      const formStateLocationKey = _.findKey(
        formstate,
        (value, key) => key !== "currentnode" && value.type === "location"
      );

      const mainAddress = formstate["a"].nodestate["10505"].answer; // this gets the main address that yes will always be set to.

      for (var location_ of locations_) {
        if (location_.answer == "Yes") {
          // Ensure each part of the path exists
          if (
            qf &&
            qf.formstate &&
            formid &&
            qf.formstate[formid] &&
            qf.formstate[formid].nodestate &&
            location_ &&
            location_.locationid
          ) {
            const nodeKey = "location_" + location_.locationid + "_500110";

            // Initialize the object if it doesn't exist
            // if (!qf.formstate[formid].nodestate[nodeKey]) {
            //   qf.formstate[formid].nodestate[nodeKey] = {};
            // }

            // Check if the source of the answer exists
            if (
              formstate &&
              formstate["a"] &&
              formstate["a"].nodestate &&
              formstate["a"].nodestate["10505"] &&
              formstate["a"].nodestate["10505"].answer &&
              qf.formstate[formid].nodestate[nodeKey]
            ) {
              // Preserve customAnswer if it exists (needed for toggle behavior)
              const existingCustomAnswer = qf.formstate[formid].nodestate[nodeKey].customAnswer;

              // Set the answer to main address
              qf.formstate[formid].nodestate[nodeKey].answer =
                formstate["a"].nodestate["10505"].answer;

              // Restore customAnswer so it can be used when switching back to "No"
              if (existingCustomAnswer) {
                qf.formstate[formid].nodestate[nodeKey].customAnswer = existingCustomAnswer;
              }
            } else {
              // Handle the case where the answer doesn't exist, possibly set a default value or log an error
            }
          }

          /*
          We need to update the location node with the correct information and not touch other possible locations
          Because all the field information is being stored in session storage we need to make sure its also updated real time
          when any changes occurs to the location address. but only while focusing the changes on the current location node.

          formstate.currentnode.locationid tracks the current location the user is current looking at
          */

          if (
            formstate.currentnode.locationid === location_.locationid &&
            formstate["a"] &&
            formstate["a"].nodestate &&
            formstate["a"].nodestate["10505"] &&
            typeof formstate["a"].nodestate["10505"].answer !== "undefined"
          ) {
            sessionStorage.setItem(
              "location_" + location_.locationid + "_500110",
              JSON.stringify(formstate["a"].nodestate["10505"].answer)
            );
          }
        } else {
          /** if the user selected no, we need to preserve their custom address */

          const nodeKey = "location_" + location_.locationid + "_500110";
          const locationAddressNode = qf.formstate[formid].nodestate[nodeKey];

          // CRITICAL: Check if node exists before attempting to set properties
          if (!locationAddressNode) {
            console.warn(`Address node ${nodeKey} not found in formstate`);
            continue; // Skip this location if node doesn't exist
          }

          // Priority 1: Check if there's a cached customAnswer in Redux state
          if (locationAddressNode?.customAnswer) {
            locationAddressNode.answer = locationAddressNode.customAnswer;
          }
          // Priority 2: Check sessionStorage with _no suffix awareness
          else {
            // When "Same as Main?" is "No", read from the _no key
            const storageKey = nodeKey + "_no";
            const sessionStorageAddress = sessionStorage.getItem(storageKey);

            if (sessionStorageAddress) {
              try {
                const parsedAddress = JSON.parse(sessionStorageAddress);

                // Only set if we have valid address data
                if (parsedAddress && typeof parsedAddress === 'object') {
                  locationAddressNode.answer = parsedAddress;
                  console.log(`Restored address from sessionStorage: ${storageKey}`);
                }
              } catch (e) {
                console.error(`Failed to parse address from sessionStorage: ${storageKey}`, e);
                // If parsing fails, fall through to backend data
              }
            }

            // Priority 3: Fall back to backend data if available
            if (
              !locationAddressNode.answer &&
              formstate[formStateLocationKey]?.nodestate[nodeKey]?.answer
            ) {
              locationAddressNode.answer =
                formstate[formStateLocationKey].nodestate[nodeKey].answer;
            }
          }
        }
      }
    },

    filterFormsOrder: (qf, action) => {
      let filteredArray = action.payload;

      //
      if (filteredArray && filteredArray.length) {
        //
        qf.backupformsorder = qf.formsorder;
        qf.formsorder = filteredArray.split(",");
        qf.tmpformsorder = filteredArray.split(",");
        //
        //
        //
        if (
          filteredArray.split(",").length &&
          !filteredArray.split(",").includes(qf.formstate.currentnode.formid)
        ) {
          qf.formstate.currentnode = qf.formstate[qf.formsorder[0]].currentnode;
        }
      }
    },

    updatebackupformsorder: (qf, action) => {
      let formorder = action.payload.formsorder;
      let tmporder = action.payload.tmporder;
      let ogformstate = action.payload.ogformstate;
      if (formorder && formorder.length) qf.backupformsorder = formorder;
      else if (tmporder && tmporder.length) {
        qf.tmpformsorder = tmporder;
      } else if (ogformstate) {
        qf.formstate = ogformstate;
      }
    },

    updateAddressParts: (qf, action) => {
      let formid = action.payload.formid;
      let { formstate, formsorder, doc } = qf;
      let answers = { doc };
      let { order, state } = giveLocationAddresses({
        formsorder,
        formstate,
        answers,
      });

      let { locationsorder, locationstate } = qf.formstate[formid];

      locationsorder.forEach((locationid) => {
        locationstate[locationid].addressPart =
          state[locationid].address?.postalcode;

        locationstate[locationid].addressObject = state[locationid].address;
      });
    },
    handleExpressApplication: (qf, action) => {
      qf.isExpressApplication = !qf.isExpressApplication;

     let anyinterestInsurer = (q) => {
      if( !q.interestedinsurercodes?.length || q.forceimportance ){
        return true
      }
      let x = q.interestedinsurercodes.some((r) => qf.doc.interestedinsurercodes.includes(r)  ) 
      if(x)
          return true
      return false;
      }
      if (!qf.isExpressApplication) {
        qf.nonPriorityGroups = [];
      } else {
        let allQuestions = qf.questiontable;
        for (let formid of qf.formsorder) {
          let grouporder = qf.formstate[formid].groupsorder;
          if (!grouporder) continue;
          for (let groupid of grouporder) {
            let questionOrder =
              qf.formstate[formid].groupstate[groupid].questionsorder;
            let nodeState = qf.formstate[formid].nodestate
            // let isFound = nodeState.interestedinsurercodes.some((r) =>
            //   qf.doc.interestedinsurercodes.includes(r)
            // );
            let questionDetails =  Object.values(Object.fromEntries(
                Object.entries(nodeState).filter(([key]) => questionOrder.includes(key))
              ));
            // let questionDetails = allQuestions.filter((q) =>
            //   questionOrder.includes(q.id)
            // );
            if (_.isEmpty(questionDetails)) continue;
            var filteredArr = questionDetails.filter(
              (x) => x.importance > qf.expressImportanceFactor && anyinterestInsurer(x)
            );
            if (filteredArr.length == 0 && groupid != 'h_100') {
              qf.nonPriorityGroups.push(groupid);
            }
          }
        }
      }
    },
    addGroupIdToNonPriorityGroups: (qf, action) => {
      // console.log(action.payload)
      qf.nonPriorityGroups.push(action.payload);
    },
    handleflashQid: (qf, action) => {
      if (!action.payload) qf.flashQid = null;
      else qf.flashQid = action.payload;
    },
    handleBypassImportanceQ: (qf, action) => {
      if (!action.payload) qf.bypassImportanceQ = false;
      else qf.bypassImportanceQ = action.payload;
      if (qf.doc?.otherdetails) {
        qf.doc.otherdetails.bypassImportanceQ = qf.bypassImportanceQ;
      }
    },
  },
});

export const {
  resetState,
  storeProspectIdFromQF,
  initiateCustomerSucceed,
  bpFetchFailure,
  bpFetchSucceed,
  scheduleFileSucceed,
  scheduleFileStart,
  bpFetchInitialized,
  currentNodeChangedOnDirectClick,
  currentNodeChangedOnDirectLocationClick,
  currentNodeChangedOnDirectBuildingClick,
  currentNodeChangeOnNextClick,
  currentNodeChangeOnPreviousClick,
  currentNodeChangedOnDirectGroupClick,
  currentNodeChangedOnDirectLocationGroupClick,
  updateFormsFailed,
  updateFormsInitiated,
  updateFormsSuccess,
  updateDocumentSuccess,
  updateBMSInitiated,
  updateBMSSuccess,
  updateOperationSuccess,
  currentNodeChanged,
  addLocationToForm,
  addBuildingToForm,
  removeLocationToForm,
  removeBuildingToForm,
  AddtoClientLog,
  answerChanged,
  addMetaData,
  manipulateQuestion,
  implementProductGroupsandQuestions,
  gmapPredictionSucceed,
  gmapPredictionInitalized,
  gmapPredictionFailed,
  gmapPostalCodeSucceed,
  changeNodeOfScheduleQuestion,
  dataForCHSFailed,
  dataForCHSInitialized,
  openCHSconfirmationModalFun,
  makeCurrentNodesToFirstNode,
  updateTrackingQAnsweredFinalValues,
  prefillAddressParts,
  filterFormsOrder,
  updatebackupformsorder,
  updateAddressParts,
  setShowFirstAutoAddedBuilding,
  handleExpressApplication,
  addGroupIdToNonPriorityGroups,
  handleflashQid,
  handleBypassImportanceQ,
} = slice.actions;

export default slice.reducer;

// action creator

export const getExcelScheduleFile = (data) => 
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/getScheduleExcel",
    method: "post",
    data: data,
    onStart: scheduleFileStart.type,
    onSuccess: scheduleFileSucceed.type,
    // onError: bpFetchFailure.type,
  });


export const verifyBrokerAgainstProspectQF = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/getprospectdoc",
    method: "post",
    data: data,
    onStart: bpFetchInitialized.type,
    onSuccess: bpFetchSucceed.type,
    onError: bpFetchFailure.type,
  });

export const updateOtherDetails = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/updateOtherDetails",
    method: "post",
    data: data,
  });

export const updateOwner = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/updateOwner",
    method: "post",
    data: data,
  });

export const updateProspectForms =
  ({ updateFromState, updateFormsOrder, updateFormStateAndOrder }) =>
  (dispatch, getState) => {
    let { prospectid, formstate, formsorder } = getState().entities.qf;

    let data = { prospectid };

    if (updateFromState) {
      data = { ...data, formstate };
    }
    if (updateFormsOrder) {
      data = { ...data, formsorder };
    }
    if (updateFormStateAndOrder) {
      data = { ...data, formstate, formsorder };
    }
    console.log(updateFromState, updateFormsOrder, updateFormStateAndOrder);
    dispatch(
      apiCallBegan({
        serviceUrl: process.env.REACT_APP_BASICSERVICE,
        url: "/api/prospects/update",
        method: "post",
        data: data,
        onStart: updateFormsInitiated.type,
        onSuccess: updateFormsSuccess.type,
        onError: updateFormsFailed.type,
      })
    );

    return;
  };

export const updateBmsInfo =
  ({ action, postdata }) =>
  (dispatch, getState) => {
    let { prospectid, formstate, formsorder, bms, doc, updatingBMS, updating } =
      getState().entities.qf;
    let brokerBMSinfo = getState().entities.broker?.information?.otherinfo?.bms;
    let brokerageBMSinfo =
      getState().entities.brokerage?.information?.otherinfo?.bms;
    let apiCall = false;
    let client_details_answers = null;
    if (
      !Array.isArray(brokerBMSinfo) ||
      ["", null].includes(brokerBMSinfo[0]) ||
      !brokerageBMSinfo?.brokeragecode
    ) {
      //console.log("Broker/Brokerage BMS not configured");
      return;
    }
    // let postdata = null;
    if (!prospectid && doc?._id) {
      prospectid = doc._id;
    }
    if (postdata?.prospectid) {
      prospectid = postdata.prospectid;
    }
    if (!prospectid && action != "brokerage_config") {
      //console.log("ProspectID is missing, ", action)
      return;
    }
    if (doc?.otherdetails?.bms?.clientInfo == "no_creation") {
      return;
    }
    if (action == "create_client") {
      //console.log("Calling create client")
      //console.log(doc?.otherdetails?.bms)
      let clientInfoExists = doc?.otherdetails?.bms?.clientInfo;
      let client_details = Object.values(formstate.a.nodestate).filter(
        (x) => x.permanentcode != ""
      );
      client_details_answers = client_details.filter((x) => x.answer);

      if (
        client_details_answers.length == client_details.length &&
        !bms.clientInfo &&
        !updatingBMS &&
        !clientInfoExists
      ) {
        if (postdata?.clientCode) {
          client_details_answers.push({ clientCode: postdata.clientCode });
        }
        apiCall = true;
        postdata = client_details_answers;
      }
    }
    if (action == "to_market") {
      // check to see if already sent to market
      apiCall = true;
    }
    if (
      ["send_quotes", "bind_quote", "close_app", "brokerage_config"].includes(
        action
      )
    ) {
      apiCall = true;
    }
    let payload = { prospectid, data: postdata, action };
    if (apiCall) {
      dispatch(
        apiCallBegan({
          serviceUrl: process.env.REACT_APP_BASICSERVICE,
          url: "/api/prospects/bms/update",
          method: "post",
          data: payload,
          onStart: updateBMSInitiated.type,
          onSuccess: updateBMSSuccess.type,
          onError: updateBMSSuccess.type,
        })
      );
    }

    return;
  };

export const updateProspectStatus = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/updatestatus",
    method: "post",
    data: data,
});

export const acturisBmsBind = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/eic/bms/acturis",
    method: "post",
    data: data,
});

export const uploadDocument = (data, optionalData) => (dispatch, getState) => {
  let { prospectid, formstate, formsorder, chs } = getState().entities.qf;
  if(!optionalData.prospectid)
    optionalData.prospectid = prospectid;
  optionalData.chs = chs;
  data.append("data", JSON.stringify(optionalData));
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/uploadDocument",
      method: "post",
      data: data,
      onStart: updateFormsInitiated.type,
      onSuccess: updateDocumentSuccess.type,
      onError: updateFormsFailed.type,
    })
  );
};

export const deleteDocument = (data) => (dispatch, getState) => {
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/deleteDocument",
      method: "delete",
      data: data,
      onStart: updateFormsInitiated.type,
      onSuccess: updateDocumentSuccess.type,
      onError: updateFormsFailed.type,
    })
  );
};

export const addOperation = (operation, type) => (dispatch, getState) => {
  let { prospectid, formstate, formsorder, chs } = getState().entities.qf;
  //let type = "add"
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/updateOperations",
      method: "post",
      data: { operation, prospectid, type, chs },
      onStart: updateFormsInitiated.type,
      onSuccess: updateOperationSuccess.type,
      onError: updateFormsFailed.type,
    })
  );
};

export const modifyPackage = (directive, type) => (dispatch, getState) => {
  let { prospectid, formstate, formsorder, chs } = getState().entities.qf;
  //let type = "add"
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/modifyPackage",
      method: "post",
      data: { directive, prospectid, type, chs },
      onStart: updateFormsInitiated.type,
      onSuccess: updateOperationSuccess.type,
      //onError: updateFormsFailed.type,
    })
  );
}; 

export const updateAppWithPackage = (parms) => async (dispatch, getState) => {
  
  dispatch(implementProductGroupsandQuestions(parms))
 
  const { doc, prospectid } = getState().entities.qf;
  const updatedData = {
    // Construct the data for the backend based on the updated state
    prospectid,
    triagedata: doc.otherdetails.triagedata,
    productcode: doc.answers.productcode
    // Add other relevant data
  };
  // Dispatch the backend update
  await dispatch(updateOtherDetails(updatedData));
}

export const addLocationToFormThunk =
  ({ formid }) =>
  (dispatch, getState) => {
    let { questionFlowUserMode } = getState().entities.components;

    if (questionFlowUserMode !== INSURER) {
      dispatch(addLocationToForm({ formid }));
    }

    return;
  };

export const addBuildingToLocationState =
  ({ formid, locationid, buildingIndex, focusDisabled }) =>
  (dispatch, getState) => {
    let { questionFlowUserMode } = getState().entities.components;

    if (questionFlowUserMode !== INSURER) {
      dispatch(
        addBuildingToForm({ formid, locationid, buildingIndex, focusDisabled })
      );
    }

    return;
  };

export const removeLocationToFormThunk =
  ({ formid, locationid }) =>
  (dispatch, getState) => {
    let { questionFlowUserMode } = getState().entities.components;

    let isMoreThanOneLocationAvailable = !isOnlyOneLocationAvaliable({
      formid,
      formstate: { ...getState().entities.qf.formstate },
    });

    if (questionFlowUserMode !== INSURER && isMoreThanOneLocationAvailable) {
      dispatch(removeLocationToForm({ formid, locationid }));
      dispatch(updateTrackingQAnsweredFinalValues({ formChangedId: formid }));
    }

    return;
  };

export const removeBuildingToFormThunk =
  ({ formid, locationid, buildingid }) =>
  (dispatch, getState) => {
    let { questionFlowUserMode } = getState().entities.components;

    if (questionFlowUserMode !== INSURER) {
      dispatch(removeBuildingToForm({ formid, locationid, buildingid }));
      dispatch(updateTrackingQAnsweredFinalValues({ formChangedId: formid }));
    }

    return;
  };

export const updateProspectFormsForClient =
  ({ updateFromState, updateFormsOrder, updateFormStateAndOrder }) =>
  (dispatch, getState) => {
    let { chs, formstate, formsorder, backupformsorder, tmpformsorder } =
      getState().entities.qf;
    let data = { id: chs };
    let forceAddFormsOrder = false;
    let newlyAddedForm = formsorder.filter(
      (x) => !backupformsorder?.includes(x)
    );
    // this if statements check to see if we need to removed a group from the order
    if (
      tmpformsorder &&
      !(
        tmpformsorder.length === formsorder.length &&
        tmpformsorder.every((val) => formsorder.includes(val))
      )
    ) {
      if (tmpformsorder.length < formsorder.length) {
        //re-register the tmporder with newly added group
        dispatch(updatebackupformsorder({ tmporder: formsorder }));
      } else {
        let removegroups = tmpformsorder.filter((x) => !formsorder.includes(x));
        backupformsorder = backupformsorder.filter(
          (x) => !removegroups.includes(x)
        );
        var newFormState = { ...formstate };

        for (let rmgroup of removegroups) {
          delete newFormState[rmgroup];
        }
        formstate = { ...newFormState };
        dispatch(updatebackupformsorder({ ogformstate: newFormState }));
        dispatch(updatebackupformsorder({ tmporder: formsorder }));
        dispatch(updatebackupformsorder({ formsorder: backupformsorder }));
        updateFormsOrder = true;
        forceAddFormsOrder = true;
        formsorder = [...backupformsorder];
      }
    }
    if (newlyAddedForm?.length && backupformsorder) {
      forceAddFormsOrder = true;
      formsorder = [...backupformsorder, ...newlyAddedForm].sort((a, b) =>
        a.localeCompare(b)
      );
      backupformsorder = [...formsorder];
      updateFormsOrder = true;
      dispatch(updatebackupformsorder({ formsorder }));
    }
    if (updateFromState) {
      data = { ...data, formstate };
    }
    if (updateFormsOrder && (!backupformsorder || forceAddFormsOrder)) {
      data = { ...data, formsorder };
    }
    if (updateFormStateAndOrder) {
      if (!backupformsorder || forceAddFormsOrder)
        data = { ...data, formstate, formsorder };
      else data = { ...data, formstate };
    }
    if (Object.keys(data).length > 1) {
      dispatch(
        apiCallBegan({
          serviceUrl: process.env.REACT_APP_BASICSERVICE,
          url: "/api/prospects/updateforclient",
          method: "post",
          data: data,
          onStart: updateFormsInitiated.type,
          onSuccess: updateFormsSuccess.type,
          onError: updateFormsFailed.type,
        })
      );
      // if(newlyAddedForm.length){
    }

    // }

    return;
  };

export const submitChangesForClient = (params) => (dispatch, getState) => {
  let { chs, formstate, formsorder, backupformsorder } = getState().entities.qf;

  let data = { id: chs, data: params };
  //
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/submitforclient",
      method: "post",
      data: data,
      onStart: updateFormsInitiated.type,
      onSuccess: updateFormsSuccess.type,
      onError: updateFormsFailed.type,
    })
  );

  return;
};

export const submitConsentForClient = (params) => (dispatch, getState) => {
  let { chs, formstate, formsorder, backupformsorder } = getState().entities.qf;

  let data = { id: chs, data: params };
  //
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/submitConsentforclient",
      method: "post",
      data: data,
      onStart: updateFormsInitiated.type,
      onSuccess: updateFormsSuccess.type,
      onError: updateFormsFailed.type,
    })
  );

  return;
};

export const updatePermanentCodeDetails = () => (dispatch, getState) => {
  let { prospectid, permanentcodes } = getState().entities.qf;

  let data = { prospectid, permanentcodedetails: permanentcodes };

  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/prospects/updatepermanentcodedetails",
      method: "post",
      data: data,
    })
  );

  return;
};

export const getGoogleMapPredictions = (data) => (dispatch, getState) => {
  let { chs } = getState().entities.qf;
  let { questionFlowUserMode } = getState().entities.components;
  if (chs && questionFlowUserMode === CLIENT) {
    data.chs = chs;
  }
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/gmap/predictions",
      method: "post",
      data: data,
      onStart: gmapPredictionInitalized.type,
      onSuccess: gmapPredictionSucceed.type,
      onError: gmapPredictionFailed.type,
    })
  );
};

export const getGoogleMapPostalCode = (data) => (dispatch, getState) => {
  let { chs } = getState().entities.qf;
  let { questionFlowUserMode } = getState().entities.components;
  if (chs && questionFlowUserMode === CLIENT) {
    data.chs = chs;
  }
  dispatch(
    apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/gmap/postalcode",
      method: "post",
      data: data,
      onSuccess: gmapPostalCodeSucceed.type,
    })
  );
};

export const getCHSdata = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/chsinfo",
    method: "post",
    data: data,
    onStart: dataForCHSInitialized.type,
    onSuccess: bpFetchSucceed.type,
    onError: dataForCHSFailed.type,
  });

export const initiateCustomerById = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/initiateCustomerById",
    method: "post",
    data: data,
    onSuccess: initiateCustomerSucceed.type,
    onError: dataForCHSFailed.type,
  });

// Selector
export const getPermanentCodeDetailsFromDoc = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.doc.permanentcodedetails
);

export const getScheduleFile = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.scheduleFile
);

export const getBMSPayload = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.bmsPayload
);

export const getBypassImportanceQ = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.doc?.otherdetails?.bypassImportanceQ
);

export const getflashQId = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.flashQid
);

export const getopenCHSconfirmationModal = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.openCHSconfirmationModal
);

export const getIsProspectUpdating = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.updating
);
export const getIsProspectSucceed = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isUpdated
);
export const getIsProspectFailed = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isUpdateFailed
);
export const getProspectFailedResponse = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.updareFormError
);
export const getIsProspectDocument = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.documentPayload
);
export const getProspectIdFromQF = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.prospectid
);

export const getIsBpFetching = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isBpFetching
);

export const getIsBpSuccess = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isBpFetchSuccess
);

export const getIsBpFailed = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isBpFetchFailed
);

export const getFormsOrder = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.formsorder
);

export const getFormState = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.formstate
);

export const getCurrentNode = createSelector(
  (state) => state.entities.qf,
  (qf) => qf?.formstate?.currentnode
);

export const getCurrentNodeFormId = createSelector(
  (state) => state.entities.qf,
  (qf) => {
    try {
      return qf.formstate.currentnode.formid;
    } catch (e) {
      return null;
    }
  }
);

export const getGmapPredictions = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.gmapPredictions
);

export const getShowFirstAutoAddedBuildingState = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.showFirstAutoAddedBuilding
);

export const getGmapPostalCodeData = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.gmapPostalCodeData
);

export const getPermanentCodes = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.permanentcodes
);

export const getProspectDoc = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.doc
);

export const getChsDataStatus = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.chsdataloading
);

export const getGroupsOrder = (formid) => (state) =>
  state.entities.qf.formstate[formid].groupsorder;

export const getGroupsOrderFromLocationState =
  ({ formid, locationid }) =>
  (state) =>
    state.entities.qf.formstate[formid].locationstate[locationid].groupsorder;

export const getGroupState = (formid, groupid) => (state) => {
  if (state.entities.qf.formstate[formid].groupstate)
    return state.entities.qf.formstate[formid].groupstate[groupid];
  return null;
};

export const getLocationsOrder = (formid) => (state) =>
  state.entities.qf.formstate[formid].locationsorder;

export const getFormText = (formid) => (state) => {
  try {
    return state.entities.qf.formstate[formid].text[
      state.entities.broker.information.languagepreference
    ];
  } catch {
    return "";
  }
};

export const getFormType = (formid) => (state) => {
  return state.entities.qf?.formstate[formid]?.type;
};

export const getFormAllInOnePage = (formid) => (state) =>
  state.entities.qf.formstate[formid]?.allinonepage;

export const getMasterGroupText = (formid, groupid) => (state) =>
  state.entities.qf.formstate[formid].groupstate[groupid].text[
    state.entities.broker.information.languagepreference
  ];

export const getLocationGroupText =
  ({ formid, groupid, locationid }) =>
  (state) =>
    state.entities.qf.formstate[formid].locationstate[locationid].groupstate[
      groupid
    ].text[state.entities.broker.information.languagepreference];

export const getQuestionOrder = (formid, groupid) => (state) =>
  state.entities.qf.formstate[formid].groupstate[groupid].questionsorder;

export const getLocationQuestionOrder =
  ({ formid, groupid, locationid }) =>
  (state) =>
    state.entities.qf.formstate[formid].locationstate[locationid].groupstate[
      groupid
    ].questionsorder;

export const getBuildings =
  ({ formid, locationid }) =>
  (state) =>
    state.entities.qf.formstate[formid].locationstate[locationid].buildings;

export const getBuilding =
  ({ formid, locationid, buildingid }) =>
  (state) => {
    // Check if buildingid is not undefined and is a non-negative number
    if (buildingid !== "" && buildingid !== undefined && buildingid >= 0) {
      return state.entities.qf?.formstate[formid]?.locationstate[locationid]
        ?.buildings[buildingid];
    }
  };

export const getBuildingGroupText =
  ({ formid, groupid, locationid, buildingIndex }) =>
  (state) => {
    // Break down the nested property access to better handle potential undefined values
    const formState = state.entities.qf.formstate[formid];
    const locationState = formState?.locationstate[locationid];
    const building = locationState?.buildings?.[buildingIndex];
    const groupState = building?.groupstate[groupid];
    const languageCode = state.entities.broker.information.languagepreference;
    const text = groupState?.text?.[languageCode];

    // Debugging logs
    // console.log("Form State:", formState);
    // console.log("Location State:", locationState);
    // console.log("Building:", building);
    // console.log("Group State:", groupState);
    // console.log("Language Code:", languageCode);
    // console.log("Text:", text);

    if (!text) {
      console.error("Text is undefined or not found");
    }

    return text;
  };

export const getBuildingQuestionOrder =
  ({ formid, groupid, locationid, buildingIndex }) =>
  (state) =>
    state.entities.qf.formstate[formid].locationstate[locationid].buildings[
      buildingIndex
    ].groupstate[groupid].questionsorder;

export const getNode =
  ({ formid, questionid, locationid, isBuilding, buildingIndex }) =>
  (state) => {
    let formtype = state.entities?.qf?.formstate?.[formid]?.type;

    let nodeid = formtype
      ? FormProperties({ formtype }).getNodeId({
          questionid,
          locationid,
        })
      : null;

    //
    if (isBuilding) {
      nodeid =
        "location_" +
        locationid +
        "_building_" +
        buildingIndex +
        "_" +
        questionid;
      // 'location_1_building_0_58300'

      //
    }

    //

    let returnValue = null;

    try {
      returnValue = state.entities.qf.formstate[formid].nodestate[nodeid];
    } catch (e) {}

    //
    //
    return returnValue;
  };

export const getNodesSum =
  ({ formid, questionids, locationid }) =>
  (state) => {
    let formtype = state.entities?.qf?.formstate?.[formid]?.type;
    let returnValue = 0;
    if (!questionids) return 0;
    for (var questionid of questionids) {
      let nodeid = formtype
        ? FormProperties({ formtype }).getNodeId({
            questionid,
            locationid,
          })
        : null;
      try {
        if (state.entities.qf.formstate[formid].nodestate[questionid].answer)
          returnValue +=
            state.entities.qf.formstate[formid].nodestate[questionid].answer;
      } catch (e) {}
    }
    return returnValue;
  };

export const getQuestionDetailsFromQuestionTable =
  ({ questionid }) =>
  (state) => {
    let allQuestions = state.entities.qf.questiontable;

    let questionDetails = allQuestions.filter((q) => q.id === questionid);

    if (_.isEmpty(questionDetails)) return null;

    return questionDetails[0];
  };

export const getGroupQuestionDetailsFromQuestionTable =
  ({ questionid, formid, groupid, locationid, buildingid, useFormState=false }) =>
  (state) => {
    let groupOrLocationState = "groupstate";
    let questionOrder = null;
    //console.log("groupid:::", groupid)
    //console.log(state.entities.qf.formstate)
    if (![null, undefined].includes(buildingid)) {
      groupOrLocationState = "locationstate";
      questionOrder =
        state.entities.qf.formstate[formid]["locationstate"][locationid]
          .buildings[buildingid].groupstate[groupid].questionsorder;
    } else if (!state.entities.qf.formstate[formid]?.groupstate) {
      groupOrLocationState = "locationstate";
      // console.log("formid", formid);
      // console.log("locationid", locationid);
      // console.log("groupid: ", groupid);
      // console.log((state.entities.qf.formstate[formid]["locationstate"]));
      // console.log("-----------------------------------")
      questionOrder =
        state.entities.qf.formstate[formid]["locationstate"][locationid]
          .groupstate[groupid].questionsorder;
    } else {
      questionOrder =
        state.entities.qf.formstate[formid].groupstate[groupid].questionsorder;
      if (
        formid == "c" &&
        state.entities.qf.formstate[formid].groupstate[groupid].dynamic
      ) {
        questionOrder = questionOrder.map((op) => {
          const match = op.match(/operation_\d+_(\d+)/);
          return match ? match[1] : null;
        });
      }
    }
    let allQuestions = state.entities.qf.questiontable;
    let questionDetails = allQuestions.filter((q) =>
      questionOrder.includes(q.id)
    );
    if(useFormState){
      let nodeState = state.entities.qf.formstate[formid].nodestate
      questionDetails =  Object.values(Object.fromEntries(
        Object.entries(nodeState).filter(([key]) => questionOrder.includes(key))
      ));
    }

    if (_.isEmpty(questionDetails)) return null;

    return questionDetails;
  };

export const getIsGroupQuestionsAnyPriority =
  ({ formid, groupid }) =>
  (state) => {
    if (!state.entities.qf.isExpressApplication) {
      return true;
    }
    let questionOrder = state.entities.qf.formstate[formid].groupstate[groupid].questionsorder;
    let allQuestions = state.entities.qf.questiontable;
    let nodeState = state.entities.qf.formstate[formid].nodestate

    // let questionDetails = allQuestions.filter((q) =>
    //   questionOrder.includes(q.id)
    // );
    let anyIntrestedInsurer = (x) => {
      if(!x?.interestedinsurercodes.length || x?.forceimportance){
        return true
      }
      let trex =  x.interestedinsurercodes.some((r) =>
          state.entities.qf.doc.interestedinsurercodes.includes(r));
      return trex
    }
    let questionDetails =  Object.values(Object.fromEntries(
      Object.entries(nodeState).filter(([key]) => questionOrder.includes(key))
    ));

    if (_.isEmpty(questionDetails)) return true;

    var filteredArr = questionDetails.filter((x) => ( x.importance > 3 && anyIntrestedInsurer(x) ) || x.answer  );
    if (filteredArr.length == 0) {
      return false;
    }
    return true;
  };

export const getIsFormAnyPriority =
  ({ formid }) =>
  (state) => {
    if (!state.entities.qf.isExpressApplication || formid == "h") {
      return true;
    }
    let groupsorder = state.entities.qf.formstate[formid].groupsorder;
    let nonPriorityGroups = state.entities.qf.nonPriorityGroups;
    let hideForm = groupsorder?.every((v) => nonPriorityGroups?.includes(v));
    if (hideForm) {
      return false;
    }
    return true;
  };

export const getExpressImportanctFactor = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.expressImportanceFactor
);

export const getExpressApplication = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.isExpressApplication
);

export const getNonPriorityGroups = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.nonPriorityGroups
);

export const getCHS = createSelector(
  (state) => state.entities.qf,
  (qf) => {
    return window.location.origin + "/chs?id=" + qf.chs;
  }
);

export const getClientLog = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.clientLog
);

export const getTrackingQAnsweredFinalValues = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.trackingQAnsweredFinalValues
);

export const getTrackingQAnsweredEachForm =
  ({ formid }) =>
  (state) => {
    try {
      return state.entities.qf.trackingQAnsweredEachForm[formid];
    } catch (e) {
      return null;
    }
  };

export const getAddressPartForLocation =
  ({ formid, locationid }) =>
  (state) => {
    let returnValue = null;
    try {
      returnValue =
        state.entities.qf.formstate[formid].locationstate[locationid]
          .addressPart;
    } catch (e) {}
    return returnValue;
  };

export const getSecondLevelText =
  ({ formid }) =>
  (state) => {
    let returnValue = null;
    try {
      returnValue =
        state.entities.qf.formstate[formid].description.secondLevelText[
          state.entities.broker.information.languagepreference
        ];
    } catch (e) {}
    return returnValue;
  };

export const getAddButtonText =
  ({ formid }) =>
  (state) => {
    let returnValue = null;
    try {
      returnValue =
        state.entities.qf.formstate[formid].description.addButtonText[
          state.entities.broker.information.languagepreference
        ];
    } catch (e) {}
    return returnValue;
  };

export const getAnswersFromDoc = createSelector(
  (state) => state.entities.qf,
  (qf) => qf.doc.answers
);
